import { Card, Collection, Heading } from '@ksyos/design-system';
import { Fragment } from 'react';
import type { AccountRequestApiResult } from '@common/interfaces/api/accountRequestsApi';
import { getSelectedLanguage } from '@frontend/translate';
import { hasAccountRequestAuthorization } from '@frontend/utils';
import { AccountRequestsCollectionItem } from './AccountRequestsCollectionItem';
import { AccountRequestsCollectionLink } from './AccountRequestsCollectionLink';

interface AccountRequestsCollectionProps {
    accountRequests: AccountRequestApiResult[];
    avatarSize?: number;
    isKsyos: boolean;
    organizationId: string;
    padding?: 'small' | 'medium';
    shadow?: boolean;
}

export function AccountRequestsCollection(props: Readonly<AccountRequestsCollectionProps>) {
    const language = getSelectedLanguage();
    const hasSupportAccountRequestReadAuthorization = hasAccountRequestAuthorization('read', true);

    if (props.isKsyos) {
        return null;
    }

    const collectionContent = (
        <Collection type="nav">
            {props.accountRequests.map((accountRequest) =>
                hasSupportAccountRequestReadAuthorization ? (
                    <AccountRequestsCollectionLink
                        accountRequest={accountRequest}
                        avatarSize={props.avatarSize}
                        key={accountRequest.id}
                        padding={props.padding}
                    />
                ) : (
                    <AccountRequestsCollectionItem
                        accountRequest={accountRequest}
                        avatarSize={props.avatarSize}
                        key={accountRequest.id}
                        padding={props.padding}
                    />
                )
            )}
        </Collection>
    );

    return (
        <Fragment>
            <Heading
                mb={4}
                mt={8}
                size="small"
            >
                {language.organization.accountRequests}
            </Heading>

            {props.shadow ? <Card>{collectionContent}</Card> : collectionContent}
        </Fragment>
    );
}
